export const GET_ROLE = 'ROLE/get_role';
export const UPDATE_ROLE = 'ROLE/update_role';
export const CREATE_ROLE = 'ROLE/create_role';
export const REMOVE_ROLE = 'ROLE/remove_role';
export const GET_SELECTED_ROLE = 'ROLE/GET_SELECTED_ROLE';

export const GET_PERMISSION = 'PERMISSION/get_permission';
export const UPDATE_PERMISSION = 'PERMISSION/update_permission';
export const CREATE_PERMISSION = 'PERMISSION/create_permission';
export const REMOVE_PERMISSION = 'PERMISSION/remove_permission';

export const GET_LIST_PERMISSION = 'PERMISSION/get_list_permission';

export const FORM_DATA = {
  name: '',
  guard_name: 'administrator',
  page: '',
};

export const FORM_DATA_PERMISSION = {
  name: '',
};
